import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { authFeature, AuthEffects } from './store';

export function provideAuthFeature(): EnvironmentProviders {
  return makeEnvironmentProviders([provideState(authFeature), provideEffects(AuthEffects)]);
}
